// See: https://github.toasttab.com/toasttab/toast-java-common/blob/076d958931558ddd4fb6874b97c7f4294ec40791/src/main/java/com/toasttab/util/ValidationUtils.java#L48
// When pricing an order, toast-orders uses some custom logic to validate the email address.
const DOMAIN_LABEL = '[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?'
const VALID_EMAIL_PATTERN =
  "^[_a-zA-Z0-9](?:[\\.\\-+]?[_A-Za-z0-9'-]){0,53}" +
  '@' +
  DOMAIN_LABEL +
  '(?:\\.' +
  DOMAIN_LABEL +
  '){0,4}' +
  '\\.[a-zA-Z]{2,20}$'
export const VALID_EMAIL_REGEX = new RegExp(VALID_EMAIL_PATTERN)
export const isValidCustomerEmail = (value: string) => {
  return VALID_EMAIL_REGEX.test(value)
}
